var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmojiSunglassesNofil(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "noCurrentFill",
    fill: "#D1D1D1",
    stroke: "noCurrentFill",
    strokeOpacity: 0,
    d: "M19,38A19,19,0,1,0,0,19,19,19,0,0,0,19,38ZM5.486,12.452A2.375,2.375,0,0,1,7.79,9.5h6.46a2.375,2.375,0,0,1,2.375,2.375v.276a10.375,10.375,0,0,1,4.75,0v-.276A2.375,2.375,0,0,1,23.75,9.5h6.46a2.375,2.375,0,0,1,2.3,2.952l-.739,2.95A4.75,4.75,0,0,1,27.168,19H26.125a4.75,4.75,0,0,1-4.736-4.368,7.656,7.656,0,0,0-4.779,0A4.75,4.75,0,0,1,11.875,19h-1.04a4.75,4.75,0,0,1-4.607-3.6Zm6.315,10.7a8.314,8.314,0,0,0,14.4,0,1.187,1.187,0,1,1,2.057,1.188,10.691,10.691,0,0,1-18.516,0A1.187,1.187,0,1,1,11.8,23.156Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmojiSunglassesNofil);
export default __webpack_public_path__ + "static/media/emoji-sunglasses-nofil.5ea39a3fd13a90d94c8c1185f035a49c.svg";
export { ForwardRef as ReactComponent };